/*
    A single radio content style view element
*/
import View from '@ckeditor/ckeditor5-ui/src/view';
import uid from '@ckeditor/ckeditor5-utils/src/uid';
import ContentStyleRadio from './content-style-radio';

export default class ContentStyleRadioList extends View {
	/*
   * @param {Locale} locale
   * @param {ContentStyleModel[]} styles
   */
	constructor( locale, styles ) {
		super( locale );

		// CMS9 changed the class name.
		const viewUid = `ck-labeled-checkbox-view-${ uid() }`;
		const statusUid = `ck-labeled-checkbox-view-status-${ uid() }`;

		/**
     * The value of the collection.
     *
     * @observable
     * @member {String} #value
     */
		this.set( 'value' );

		/**
     * The `id` attribute of the input (i.e. to pair with a `<label>` element).
     *
     * @observable
     * @member {String} #id
     */
		this.set( 'id' );

		/**
     * The name of the input
     *
     * @observable
     * @member {String} #value
     */
		this.set( 'name' );

		/**
     * A set of content styles for the radio list.
     *
     * @observable
     * @member {ContentStyleModel[]} #value
     */
		this.set( 'styles' );
		this.styles = styles;

		// Create the child radio buttons off of the list.
		this._createRadioButtons( viewUid, statusUid );
		this.setTemplate( {
			tag: 'ul',
			children: this.buttons
		} );
	}

	render() {
		super.render();

		// Set the button state.
		const set = value => {
			for ( const button of this.buttons ) {
				const checked = button.value === value;
				if ( checked !== button.checked ) {
					button.checked = checked;
				}
			}
		};
		set();

		// Bind the value of the list to the checked states of the individual radio buttons.
		this.on( 'change:value', ( evt, name, value ) => {
			set( value );
		} );

		for ( const button of this.buttons ) {
			button.on( 'change:checked', () => {
				if ( button.checked && this.value !== button.value ) {
					this.value = button.value;
				}
			} );
		}
	}

	/**
   * Refresh the button state.
   */
	refresh() {
		for ( const button of this.buttons ) {
			button.refresh();
		}
	}

	/**
   * Create the radio buttons.
   *
   * @param {string} viewId
   * @param {string} statusUid
   * @returns
   */
	_createRadioButtons( viewId, statusUid ) {
		const locale = this.locale;
		this.buttons = this.styles.map( style => {
			const button = new ContentStyleRadio( locale, style );
			button.set( {
				name: viewId,
				ariaDescribedById: statusUid
			} );
			return button;
		} );
	}
}
